'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"skeleton-loader":"Skeleton-module_skeleton-loader__zUpUq","preload":"Skeleton-module_preload__UAxEl","shine":"Skeleton-module_shine__HQeY-"};

exports.default = styles;
//# sourceMappingURL=Skeleton.module.scss.js.map
